import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { NullSafe } from 'src/app/core/types/null-safe.type';

@Directive({
  selector: '[appNomeGuerraPG]',
})
export class NomeGuerraPGDirective implements OnChanges {
  @Input({ required: true }) nomeCompleto: NullSafe<string>;
  @Input({ required: true }) nomeGuerra: NullSafe<string>;
  @Input({ required: true }) pgQuadro: NullSafe<string>;
  @Input() exibeNomeCompleto: NullSafe<boolean> = true;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.formatarNome();
  }

  // Civis são identificados pela ausência de pgQuadro ou por pgQuadro que contém "FUNC EXT"
  // (ex: "AG FUNC EXT", "AUX FUNC EXT"). Nunca é igual a "FUNC EXT" sozinho.
  private isCivil(): boolean {
    return !this.pgQuadro || this.pgQuadro.includes('FUNC EXT');
  }

  private formatarNome(): void {
    const elemento = this.el.nativeElement;
    const nomeCompleto = this.nomeCompleto?.trim() ?? '';
    this.renderer.setProperty(elemento, 'textContent', '');

    if (!nomeCompleto) return;

    if (this.isCivil()) {
      this.adicionarTexto(elemento, nomeCompleto);
      return;
    }

    if (!this.nomeGuerra) {
      this.adicionarTexto(elemento, `${this.pgQuadro} ${nomeCompleto}`);
      return;
    }

    if (this.exibeNomeCompleto === false) {
      this.adicionarTexto(elemento, `${this.pgQuadro} ${this.nomeGuerra}`);
      return;
    }

    this.adicionarTexto(elemento, `${this.pgQuadro} `);
    this.adicionarNomeCompleto(elemento, nomeCompleto);
  }

  private adicionarNomeCompleto(elemento: HTMLElement, nomeCompleto: string): void {
    const partesNome = nomeCompleto.split(' ');
    const destaques = new Map<number, 'inicial' | 'completo'>();
    const partesGuerra = this.nomeGuerra!
      .replace(/\./g, '')
      .split(' ')
      .filter(parte => parte.trim() !== '');

    partesGuerra.forEach(parte => {
      const termo = parte.toLowerCase();
      const indice = termo.length === 1
        ? partesNome.findIndex(nome => nome.toLowerCase().startsWith(termo))
        : partesNome.findIndex(nome => nome.toLowerCase() === termo);

      if (indice === -1) return;
      if (termo.length > 1 || !destaques.has(indice)) {
        destaques.set(indice, termo.length === 1 ? 'inicial' : 'completo');
      }
    });

    partesNome.forEach((parte, indice) => {
      if (indice > 0) this.adicionarTexto(elemento, ' ');

      const destaque = destaques.get(indice);
      if (destaque === 'completo') {
        this.adicionarDestaque(elemento, parte);
        return;
      }
      if (destaque === 'inicial') {
        this.adicionarDestaque(elemento, parte.charAt(0));
        this.adicionarTexto(elemento, parte.slice(1));
        return;
      }
      this.adicionarTexto(elemento, parte);
    });
  }

  private adicionarDestaque(elemento: HTMLElement, texto: string): void {
    const strong = this.renderer.createElement('strong');
    this.adicionarTexto(strong, texto);
    this.renderer.appendChild(elemento, strong);
  }

  private adicionarTexto(elemento: HTMLElement, texto: string): void {
    this.renderer.appendChild(elemento, this.renderer.createText(texto));
  }
}
